<template>
    <div id="shop" class="container-fluid content">
        <iframe src="https://shop.spreadshirt.de/sandkastenliga" align="middle" width="1017px" height="900px" border="0"></iframe>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        mounted(){
            window.spread_shop_config = {
                shopName: 'sandkastenliga',
                prefix: 'https://shop.spreadshirt.de',
                baseId: 'shop',
                locale: 'de_DE',
                usePushState: false,
                updateMetadata: true,
            };
            let spreadScript = document.createElement('script')
            spreadScript.setAttribute('src', 'https://shop.spreadshirt.net/js/shopclient.nocache.js')
            document.head.appendChild(spreadScript)
        }
    }
</script>
<style>
    .customPageBackground {
        background-color: #F0FFAC!important;
    }
    .sprd-bg-m1 {
        background-color: #F0FFAC!important;
    }
    .sprd-bg-m3 {
        background-color: #F0FFAC!important;
    }
</style>
